import React, { Suspense, useLayoutEffect, useRef, useState } from "react";
import { useContext, useEffect } from "react"
import { SubmissionContext } from "./SubmissionFormContext"
import { PageContext } from "./PageContext";
import { UserContext } from "./UserContext";
import { GetLongDateTime } from "./DateTimeHelpers";
import parse from "html-react-parser";
import sanitizeHtml from "sanitize-html";
import { getPackageData } from "../services/apiService";
import { Grid, GridColumn, GridCustomCellProps} from "@progress/kendo-react-grid";
import { SubmitSummaryInfo } from "./InfoBoxes";
import { Checkbox,CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { DateTime } from 'luxon';


export function SummaryReport(){
    const subContext = useContext(SubmissionContext);
    const setSubmitAddWatch=(event:CheckboxChangeEvent)=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,addWatch:event.value}));
    }
    return(
    <>
        <SubmitSummaryInfo/>
        <Checkbox className="mt-2 mb-2" onChange={setSubmitAddWatch} checked={subContext?.submitForm.addWatch}>&nbsp;Add this ad to my watchlist</Checkbox>
        <SummaryTicket/>
    </>
    )
}

export function SummaryTicket(){

    const [pkgReady, setPkgReady]=useState(false);
    const SummaryHeader=()=>{
        const subContext = useContext(SubmissionContext);
        const userContext =useContext(UserContext);
        const pageContext = useContext(PageContext);

        var trusted = true;
        console.log(pageContext?.glSettings);
        if (pageContext?.glSettings.EnableTrustedReps=="true"){
            if (userContext?.user.type==0 ||userContext?.user.type==1){
                trusted=userContext?.user.trusted;
            }
        }
        const subDate = GetLongDateTime();
        console.log(subDate);
        const HeaderGrid = ()=>{

            return(
                <div className="k-grid k-widget">
                    <table className="k-table k-grid-table k-table-md"><tbody className="k-table-body">
                        <tr className="k-table-row"><th className="k-table-th">Ad Number:</th><td className="k-table-td">{subContext?.submitForm.element}</td></tr>
                        <tr className="k-table-alt-row"><th className="k-table-th">Advertiser:</th><td className="k-table-td">{subContext?.submitForm.customer.customer}</td><th className="k-table-td">Account:</th><td className="k-table-td">{subContext?.submitForm.account}</td></tr>
                        <tr className="k-table-row"><th className="k-table-th">Submitted:</th><td className="k-table-td">{subDate}</td><th className="k-table-td">Submitted By:</th><td className="k-table-td">{userContext?.user.fullName + " (" + userContext?.user.username + ")"}</td></tr>
                        <tr className="k-table-alt-row"><th className="k-table-th">Phone:</th><td className="k-table-td">{userContext?.user.phone}</td><th className="k-table-td">Email:</th><td className="k-table-td">{userContext?.user.email}</td></tr>
                    </tbody></table>
                </div>
            )
        }
        if (subContext){
            switch (subContext.submitForm.subType){
                case "NO":
                    return(
                        <>
                            <h5 className={trusted?"neworderheader":"neworderheaderUT"}>NEW AD ORDER REPORT {trusted?"":pageContext?.glSettings.UntrustedSubmissionHeader}</h5>
                            <HeaderGrid></HeaderGrid>
                        </>
                    )
                    break;
                case "MK":
                    return(
                        <>
                            <h5 className={trusted?"neworderheader":"neworderheaderUT"}>NEW MARKETING ORDER REPORT {trusted?"":pageContext?.glSettings.UntrustedSubmissionHeader}</h5>
                            <HeaderGrid></HeaderGrid>
                        </>
                    )
                    break;
                case "SP":
                    return(
                        <>
                            <h5 className={trusted?"neworderheader":"neworderheaderUT"}>NEW SPEC AD ORDER REPORT {trusted?"":pageContext?.glSettings.UntrustedSubmissionHeader}</h5>
                            <HeaderGrid></HeaderGrid>
                        </>
                    )
                    break;
                case "OS":
                    return(
                        <>
                            <h5 className={trusted?"neworderheader":"neworderheaderUT"}>NEW OUTSOURCE ORDER REPORT {trusted?"":pageContext?.glSettings.UntrustedSubmissionHeader}</h5>
                            <HeaderGrid></HeaderGrid>
                        </>
                    )
                    break;
                case "SB":
                    if (subContext.submitForm.isHold){
                        return(
                            <>
                                <h5 className="neworderheaderResHold">NEW RESOLVE HOLD REPORT {trusted?"":pageContext?.glSettings.UntrustedSubmissionHeader}</h5>
                                <HeaderGrid></HeaderGrid>
                            </>
                        )
                    }else{
                        return(
                            <>
                                <h5 className={trusted?"neworderheader":"neworderheaderUT"}>NEW FILE SUBMISSION REPORT {trusted?"":pageContext?.glSettings.UntrustedSubmissionHeader}</h5>
                                <HeaderGrid></HeaderGrid>
                            </>
                        )
                    }
                    break;
                case "CR":
                    if (subContext.submitForm.isHold){
                        return(
                            <>
                                <h5 className={trusted?"correction":"correctionResHold"}>NEW RESOLVE HOLD REPORT REPORT {trusted?"":pageContext?.glSettings.UntrustedSubmissionHeader}</h5>
                                <HeaderGrid></HeaderGrid>
                            </>
                        )
                    }else{
                        return(
                            <>
                                <h5 className={trusted?"correction":"correctionUT"}>NEW CORRECTION REPORT {trusted?"":pageContext?.glSettings.UntrustedSubmissionHeader}</h5>
                                <HeaderGrid></HeaderGrid>
                            </>
                        )
                    }

                    break;
                case "AI":
                    return(
                        <>
                            <h5 className={trusted?"neworderheader":"neworderheaderUT"}>NEW SPEC AD ORDER FROM URL {trusted?"":pageContext?.glSettings.UntrustedSubmissionHeader}</h5>
                            <HeaderGrid></HeaderGrid>
                            <p><strong>This ad was generated from URL via ATOL</strong></p>
                        </>
                    )
                    break;
                default:
                    return(
                        <>
                        </>
                    )
            }    
        }else{
            return (<></>);
        }
    }

    const PackageData = () => {
        const subContext = useContext(SubmissionContext);
        const [data, setData] = React.useState<any[]>([]);
        const site = subContext?.submitForm.site;
        useEffect(() => {           
            setPkgReady(true);   
        }, []);

        return (
            subContext?.pkgData.length||0>0 ? (
                <div className="mt-3">
                    <p><strong>Package Information: </strong></p>
                    <Grid data={subContext?.pkgData}>
                        <GridColumn field="modID" headerClassName="hidden" title="Id" />
                        <GridColumn field="packageName" headerClassName="hidden" title="Package Name" />
                        <GridColumn field="strOut" headerClassName="hidden" title="Unit Size" />
                    </Grid>
                </div>
            ) : null
        );
    };

    const PressReadyData=()=>{
        const subContext = useContext(SubmissionContext);
        const pageContext = useContext(PageContext);
        const simplePR = pageContext?.uiFeatures.simplePressReady;

        if (subContext){
            if (subContext.submitForm.prCheck){
                if (!simplePR){
                    if (subContext.submitForm.prConfirm.value=="YES"){
                        return(<p><strong>This submission contains a fully-designed or press ready ad</strong></p>);    
                    }else{
                        return(
                            <>
                            <p><strong>This submission contains a full-designed ad that requires changes: {subContext.submitForm.prConfirm.label}</strong></p>
                            </>
                        )
                    }
                }else{
                    //Simple PRess Ready
                    return(<p><strong>This submission contains a fully-designed or press ready ad</strong></p>);    
                }
            }else{
                return(<></>)
            }
        }else{
            return(<></>)
        }
    }

    const CustomFields=()=>{
        const subContext = useContext(SubmissionContext);
        var outList:{q:string,a:string}[]=[];
        if (subContext){
            if (subContext.fields){
                if (subContext.customFieldData){
                    const custResp =
                        subContext.fields.map(field=>{
                            const regex = /<[^>]*>/g;
                            const prompt = field.label.replace(regex, '');;

                            const resp = subContext.customFieldData[field.fieldID];
                            //console.log (field.type + " " + prompt);
                            //console.log(resp);
                            if (resp!=undefined){
                                switch (field.type){
                                    case "TextBox":
                                    case "TextBoxAI":
                                    case "LongText":
                                    case "Email":
                                    case "URL":
                                        return(
                                            <div>
                                                <p><strong>{prompt}</strong></p>
                                                <p>{resp}</p>
                                            </div>
                                        );
                                        break;
                                    case "Phone":
                                        return(
                                        <div>
                                            <p><strong>{prompt}</strong></p>
                                            <p>{resp}</p>
                                        </div>
                                        );
                                        break;
                                    case "RadioButtonList":
                                        var objResp
                                        if (typeof(resp)=="string"){
                                            objResp=JSON.parse(resp);
                                        }else{
                                            objResp=resp;
                                        }
                                        const rblResp = Object(objResp).value;
                                        const rblWeight=Object(objResp).weight;
                                        return(
                                            <div>
                                                <p><strong>{prompt}</strong></p>
                                                <p>{rblResp}</p>
                                            </div>
                                        );
                                        break;
                                    case "CheckBoxList":
                                        const cblObj = JSON.parse(resp);
                                        var cblResp = "";
                                        console.log(cblObj);
                                        cblObj.forEach((obj:{index: number, text: string, value: string, weight: number}) => {
                                            console.log(obj);
                                            if (cblResp ==""){
                                                cblResp=obj.value;
                                            }else{
                                                cblResp = cblResp + ", " + obj.value;
                                            }
                                        });

                                        return(
                                            <div>
                                                <p><strong>{prompt}</strong></p>
                                                <p>{cblResp}</p>
                                            </div>
                                        )
                                        break;
                                    case "ComboBox":
                                        const cmbResp = Object(resp).value;
                                        const cmbWeight = Object(resp).weight;
                                        return(
                                            <div>
                                                <p><strong>{prompt}</strong></p>
                                                <p>{cmbResp}</p>
                                            </div>
                                        );
                                        break;
                                    case "DatePicker":
                                        const dtpResp = Object(resp);
                                        const dtDate = new Date(dtpResp)
                                        return(
                                            <div>
                                                <p><strong>{prompt}</strong></p>
                                                <p>{dtDate.toLocaleDateString(pageContext?.glSettings.Locale||"en-US")}</p>
                                            </div>
                                        );
                                        break;
                                    case "ColorPicker":
                                        const clrResp = Object(resp).text;
                                        return(
                                            <div>
                                                <p><strong>{prompt}</strong></p>
                                                <p>{clrResp}</p>
                                            </div>
                                        );                                                
                                        break;
                                    default:
                                        return(<></>);
                                }
                            }else{
                                return(<></>);
                            }
                        });
                    return (<>{custResp}</>);
                }else{
                    return(<></>)
                }
            }else{
                return(<></>)
            }
        }else{
            return(<></>)
        }
    }

    const Creatopy=()=>{
        const subContext = useContext(SubmissionContext);
        const pageContext = useContext(PageContext);
        if (subContext){
            if (pageContext){
                if (pageContext.selectedAd.temp6=="Built by Creatopy"){
                    return(<p className="mt-3"><strong>Annotations may be present.  View annotations for this ad</strong></p>)
                }else{
                    return(<></>)
                }
            }else{
                return(<></>)
            }
        }else{
            return (<></>)
        }
    }

    const RunDates=()=>{
        const subContext = useContext(SubmissionContext);
        const pageContext = useContext(PageContext);

        const CustomCell: React.FC<GridCustomCellProps> = (props) => {
                console.log(props);
                const date:Date = props.field ? props.dataItem[props.field] : undefined;
                return (
                    <td
                        {...props.tdProps}
                    >
                        {date?.toLocaleString(pageContext?.glSettings.Locale || "en-US", DateTime.DATE_SHORT)}
                    </td>
                );
            };
        if (subContext?.submitForm.subType!="SB" && subContext?.submitForm.subType!="CR"){
            if (subContext?.submitForm.runDates && subContext?.submitForm.runDates.length>0){
                return(
                    <div className="mt-3">
                        <p><strong>Run Dates & Publications: </strong></p>
                        <Grid className='mt-3' data={subContext?.submitForm.runDates}>
                            <GridColumn title='Pub Name' field='pubName'/>
                            <GridColumn title='Pub Number' field='pubNum'/>
                            <GridColumn title='Start Date' field='startDate' cells={{ data: CustomCell }}/>
                            <GridColumn title='End Date' field='endDate' cells={{ data: CustomCell }}/>
                        </Grid>
                    </div>
                )
            }else{
                return (<></>);
            }
        }else{
            return(<></>);
        }
    }
    const PickupExpire=()=>{
        const subContext = useContext(SubmissionContext);
        switch(subContext?.submitForm.pickupExpire.value){
            case "NO":
                return(<p><strong>This ad does not have an expiration date that requires adjusting.</strong></p>);
                break;
            case "BOOK":
                return(<p><strong>Change the expiration date to the date of the book</strong></p>);
                break;
            case "DATE":
                return(<p><strong>Change the expiration date to " + moment($("#sbExpireDate").data("kendoDatePicker").value()).format("L") + "</strong></p>)
                break;
            default:
                return(<></>);
        }
    }

    const Pickup=()=>{
    const subContext = useContext(SubmissionContext);
    const pageContext = useContext(PageContext);

    if (subContext?.submitForm.pickup!=""){
        return(
            <>
            <p><strong>Selected ads to pickup:</strong> {subContext?.submitForm.pickup}</p>
            {subContext?.submitForm.pickupWithChanges?<p><strong>No changes are required for this pickup.</strong></p>:null}
            {pageContext?.glSettings.ShowPickupExpiration==="True"?<PickupExpire/>
            :null}
            </>
        );    
    }else{
        return(<></>);
    }
}

    const FileUploads=()=>{
        return(<></>);
    }


    const subContext = useContext(SubmissionContext);
    const pageContext = useContext(PageContext);
    const [pkgData, setPkgData] = React.useState<any[]>([]);
    const site = subContext?.submitForm.site;
    const jobTicketRef = useRef<HTMLDivElement | null>(null);
    
    const cleanHTML=(dirty:string)=>{
        const clean = sanitizeHtml(dirty,{
            allowedTags: [
                "address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4",
                "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div",
                "dl", "dt", "figcaption", "figure", "hr", "li", "main", "ol", "p", "pre",
                "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn",
                "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp",
                "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption",
                "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr"
            ],
            allowedAttributes: {
                a: [ 'href', 'name', 'target' ],
                // We don't currently allow img itself by default, but
                // these attributes would make sense if we did.
                img: [ 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading' ]
            },
        })
        return clean;

    }


    var size:{size:string, strIn:string,strOut:string,modId:string,siteCode:string}|string;
    if (Array.isArray(subContext?.submitForm.size)){
        size=subContext?.submitForm.size[0] as {size:string, strIn:string,strOut:string,modId:string,siteCode:string};
    }else{
        size=(subContext?.submitForm.size ?? {}) as {size:string, strIn:string,strOut:string,modId:string,siteCode:string};
    }
    useEffect(()=>{
        console.log(subContext?.submitForm);
        console.log(subContext?.customFieldData);
    },[])

    
    return(
        <>
            
            <div className="subSummary" ref={jobTicketRef}>
                <SummaryHeader></SummaryHeader>
                <PackageData/>
                <PressReadyData/>
                {subContext?.submitForm.noFiles?<p className="mt-2"><strong>I am not submitting any files at this time.</strong></p>:null}
                {pageContext?.glSettings.HideMoreFilesToCome===false && subContext?.submitForm.allFilesIn?<p className="mt-2"><strong>More files to come. This ad is NOT ready for production</strong></p>:null}
                {subContext?.submitForm.multiPage?<p className="mt-2"><strong>This is a multi-page ad</strong></p>:null}
                {subContext?.submitForm.hasAnnotations?<p className="mt-3"><strong><a href={pageContext?.glSettings.ViewNotesLink+"?a="+subContext.submitForm.element+"&edit=y&user="} target="_blank">View annotations for this ad</a></strong></p>:null}
                <Creatopy/>
                <CustomFields/>
                {subContext?.submitForm.instructionsNotFollowed==true?<p><strong>SUPPLIED INSTRUCTIONS/LAYOUT WERE NOT FOLLOWED</strong></p>:null}
                {subContext?.submitForm.additionalCorrections==true?<p><strong>ADDITIONAL CORRECTIONS SUBMITTED</strong></p>:null}
                {subContext?.submitForm.instructions!=""?<div><p><strong>Instructions / Comments</strong></p><p>{parse(subContext?.submitForm.instructions||"")}</p></div>:null}
                {subContext?.submitForm.adCopy!=""?<div><p><strong>Ad Copy</strong></p><p>{parse(subContext?.submitForm.adCopy || "")}</p></div>:null}
                <RunDates/>
                <Pickup/>
                <FileUploads/>
            </div>      
        </>  
    )
}

// export function SummaryComplete(){
//     const subContext = useContext(SubmissionContext);
//     const pageContext = useContext(PageContext);
//     const [pkgData, setPkgData] = React.useState<any[]>([]);
//     const setSubmitAddWatch=(event:CheckboxChangeEvent)=>{
//         subContext?.setSubmitForm(prevObject=>({...prevObject,addWatch:event.value}));
//     }

//     const site = subContext?.submitForm.site;
//     var size:{size:string, strIn:string,strOut:string,modId:string,siteCode:string}|string;
//     if (Array.isArray(subContext?.submitForm.size)){
//         size=subContext?.submitForm.size[0] as {size:string, strIn:string,strOut:string,modId:string,siteCode:string};
//     }else{
//         size=(subContext?.submitForm.size ?? {}) as {size:string, strIn:string,strOut:string,modId:string,siteCode:string};
//     }
//     console.log(size);
//     const gridData=()=>{
       
//     }

//     useEffect(() => {
//          var newSize="";
//         if(typeof size==='string'){
//             newSize=size;
//         }else{
//             newSize=size.size;
//         }    
//         getPackageData(site?.code,newSize).then(fetchedData => {
//                 console.log(fetchedData);
//                 setPkgData(fetchedData);
//         });
//         console.log(subContext?.submitForm);
//         console.log(subContext?.customFieldData);        
//     }, []);
//     return(
//         <>
//         <SummaryHeader></SummaryHeader>
//         {pkgData.length>0 ? (
//             <div className="mt-3">
//                 <p><strong>Package Information: </strong></p>
//                 <Grid data={pkgData}>
//                     <GridColumn field="modID" headerClassName="hidden" />
//                     <GridColumn field="packageName" headerClassName="hidden" />
//                     <GridColumn field="strOut" headerClassName="hidden" />
//                 </Grid>
//             </div>
//         ) : null}
//         <PressReadyData/>
//         {subContext?.submitForm.noFiles?<p className="mt-2"><strong>I am not submitting any files at this time.</strong></p>:null}
//         {pageContext?.glSettings.HideMoreFilesToCome===false && subContext?.submitForm.allFilesIn?<p className="mt-2"><strong>More files to come. This ad is NOT ready for production</strong></p>:null}
//         {subContext?.submitForm.multiPage?<p className="mt-2"><strong>This is a multi-page ad</strong></p>:null}
//         {subContext?.submitForm.hasAnnotations?<p className="mt-3"><strong><a href={pageContext?.glSettings.ViewNotesLink+"?a="+subContext.submitForm.element+"&edit=y&user="} target="_blank">View annotations for this ad</a></strong></p>:null}
//         <Creatopy/>
//         <CustomFields/>
//         {subContext?.submitForm.instructionsNotFollowed==true?<p><strong>SUPPLIED INSTRUCTIONS/LAYOUT WERE NOT FOLLOWED</strong></p>:null}
//         {subContext?.submitForm.additionalCorrections==true?<p><strong>ADDITIONAL CORRECTIONS SUBMITTED</strong></p>:null}
//         {subContext?.submitForm.instructions!=""?<div><p><strong>Instructions / Comments</strong></p><p>{parse(sanitizeHtml(subContext?.submitForm.instructions||""))}</p></div>:null}
//         {subContext?.submitForm.adCopy!=""?<div><p><strong>Ad Copy</strong></p><p>{parse(sanitizeHtml(subContext?.submitForm.adCopy || ""))}</p></div>:null}
//         <RunDates/>
//         <Pickup/>
//         <FileUploads/>
//         </>        
//     )
// }

export const SubmitSummary=(
    <SummaryReport></SummaryReport>
)

export const SubmitComplete=()=>{   
    return (
        <div>
            <SummaryTicket/>
        </div>
    )
}

// export function SubmitResult(){
//     return(
//         <SummaryComplete></SummaryComplete>
//     )
// }